import { ContextMenuPosition, ContextMenuItemModel } from "models/view/contextMenu";
import { AppContextMenuModel } from "models/view/contextMenu/AppContextMenuModel";

export function updateContextMenuPosition(appMenus: AppContextMenuModel, item: ContextMenuItemModel, position: ContextMenuPosition): AppContextMenuModel {
    item.position = position;
    return { ...appMenus }; // todo should update state at item level...
}
